module.exports = __webpack_public_path__ + "img/lagun.08a22ea6.png";